import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Homepage from "./pages/MainCMS/MainCMS";
import Login from "./pages/Login/Login";
import BodyFriendCMS from "./pages/bodyfriend/Dashboard/DashboardBF";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/bodyfriend-cms/*" element={<BodyFriendCMS />} />
        <Route path="*" element={<Navigate replace to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
